import styled from 'styled-components';

export const Wrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 416px;
    background: #fff;
    border-radius: 4px;
    padding: 24px;
    color: rgba(0, 0, 0, 0.87);

    & h1 {
        font-weight: 500;
        line-height: 24px;
        font-size: 20px;
        margin-top: 0;
    }

    & p {
        line-height: 20px;
        font-size: 14px;
    }
`;

export const FilesWrapper = styled.div`
    overflow-y: auto;
    max-height: 252px;
    width: 100%;
`;

export const FileRow = styled.div<{ removed?: boolean }>`
    border-bottom: 1px solid #bdbdbd;
    padding: 8px 0 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${({ removed }) => (removed ? '#F4F6F8' : 'inherit')};
`;

export const ButtonsWrapper = styled.div`
    width: 74px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    & svg {
        cursor: pointer;
    }
`;

export const FilenameWrapper = styled.div`
    width: 95%;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
    white-space: nowrap;
`;

export const CloseIconWrapper = styled.div`
    position: absolute;
    top: 24px;
    right: 24px;

    & svg {
        cursor: pointer;
    }
`;

export const SubmitButtonsWrapper = styled.div`
    margin-top: 34px;
    display: flex;
    justify-content: flex-end;

    & button:first-of-type {
        margin-right: 10px;
    }

    & button {
        text-transform: none;
    }
`;

export const RemovedPagesText = styled.div`
    padding-left: 8px;
    color: #0781d7;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.28px;
    font-size: 14px;
    cursor: pointer;
    height: 36px;
    display: flex;
    align-items: center;
`;
